import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Form, Input, Row, Select, InputNumber, Space, Button, Skeleton } from 'antd';
import Conceptos from '@app/components/selects/conceptos';
import { insert, update, getById, } from '../../../../apis/MovimientoEmpleadoApi';
import { getList as getPeriodos, getDetailsById as getDetailsByPeriodId } from '../../../../apis/PeriodosApi';
import { getList as getTipoSaldos } from '../../../../apis/TipoSaldoApi';
import { getEmpleados } from '../../../../apis/OdooApi';
import { getAll as getConceptos } from '../../../../apis/ConceptoApi';
import { getList as getAllAnalitica } from '../../../../apis/OdooAnaliticaApi';
import { status_period } from '@app/constants/period';
import _ from 'lodash';

const { Option } = Select;
const App = forwardRef(function AnioPeriodo({ onOk, onCancel, form, object, values, disabledForm, period }, ref) {
    const [ID, setID] = useState(null);
    const [disabled, setDisabled] = useState(disabledForm ?? false);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(values);
    const searchInput = useRef(null);
    const [tiposSaldo, setTiposSaldo] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [tiposPeriodo, setTiposPeriodo] = useState([]);
    const [tipoPeriodoSelected, setTiposPeriodoSelected] = useState([]);
    const [detailsPeriodo, setDetailsPeriodo] = useState([]);
    const [conceptos, setConceptos] = useState([]);
    const [periodObject, setPeriodObject] = useState(period);
    const [analiticas, setAnaliticas] = useState([]);
    const [analitica, setAnalitica] = useState(null);
    //1- Sustituir 2- Sumar 3- No Sustituir, Default 1
    const [clases, setClases] = useState([
        { value: "1", text: 'Sustituir' },
        { value: "2", text: 'Sumar' },
        { value: "3", text: 'No Sustituir' },
    ]);
    const conceptoRef = React.createRef();
    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
                await getEmpleadosOdoo();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
        if (period) {
            setPeriodObject(period);
        }
    }, [period]);

    useEffect(() => {
        (async () => {
            if (object?.id > 0) {
                setID(object.id);
                await refreshData(object.id);
            }
        })();
    }, [object]);

    useEffect(() => {
        (async () => {
            if (tipoPeriodoSelected?.value > 0) {
                await getDetailsPeriodo(tipoPeriodoSelected.value);
            }
        })();
    }, [tipoPeriodoSelected]);

    useEffect(() => {
        (async () => {
            setDisabled(disabledForm)
        })();
    }, [disabledForm]);

    const refreshData = async (id) => {
        const response = await getById(id);
        if (response.ok) {
            let item = response.payload;
            setInitialValues(item);
            form.setFieldsValue(item);
        }
    }

    const getCatalogs = async () => {
        const responseConcepts = await getConceptos();
        if (responseConcepts.ok) {
            let items = responseConcepts.payload;
            setConceptos(items);
        }

        const responsePeriodos = await getPeriodos();
        if (responsePeriodos.ok) {
            let items = responsePeriodos.payload;
            setTiposPeriodo(items);
        }
        const responseTipoSaldo = await getTipoSaldos();
        if (responseTipoSaldo.ok) {
            let items = responseTipoSaldo.payload;
            setTiposSaldo(items);
        }
        const responseAnaliticas = await getAllAnalitica();
                if (responseAnaliticas.ok) {
                    let analiticasItems = responseAnaliticas.payload.map(item => ({
                        value: item.id,
                        text: item.name,
                        id: item.id,
                        originalData: item
                    }));
                    setAnaliticas(analiticasItems);
                    console.log('Analíticas cargadas:', analiticasItems);
                }
    }

    const getEmpleadosOdoo = async () => {
        const response = await getEmpleados();
        if (response.ok) {
            let items = response.payload;
            setEmpleados(items);
        }
    }

    const getDetailsPeriodo = async (id) => {
        let detailsResponse = await getDetailsByPeriodId(id);
        if (detailsResponse.ok) {
            let item = detailsResponse.payload;
            setDetailsPeriodo(item);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onCancelBtn = async () => {
        if (onCancel) {
            await onCancel();
        }
    }

    const onFinish = async () => {
        var values = form.getFieldsValue();
        var _concepto = conceptos.find(x => x.id == values.concepto_id);
        if (!_concepto) { return; }
        // var concepto = conceptoRef.current.concepto;
        await onOk({ concepto: _concepto })
    }

    const onChangeConcepto = async () => {
        let fields = form.getFieldsValue();
        form.setFieldsValue({
            ...fields,
            monto: 0,
            exento: 0,
            dias: 0,
            horas: 0,
            analitica: '',
        });
    }

    React.useEffect(() => {
        if (analiticas.length > 0 && initialValues && initialValues.analitica) {
            const analiticaId = typeof initialValues.analitica === 'object' ?
                initialValues.analitica.id : initialValues.analitica;

            const analiticaSeleccionada = analiticas.find(a => a.id === analiticaId);
            if (analiticaSeleccionada) {
                setAnalitica(analiticaSeleccionada);
            }
        }

        // Si initialValues cambia, actualizar el formulario
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [conceptos, analiticas, initialValues]);

    const changeAnalitica = async (value) => {
        var _analitica = analiticas.find(x => x.value == value);

        setAnalitica(_analitica);
    }

    return (
        <>
            <Form disabled={disabled}
                layout="vertical"
                form={form}
                requiredMark
                autoComplete="off"
                onFinish={onFinish}>
                <Row gutter={16}>
                    <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="odoo_empleado_id"
                            label="Empleado"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona un empleado',
                                },
                            ]}
                        >
                            <Select placeholder="Por favor selecciona un empleado">
                                {
                                    empleados.map((item) => <Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="concepto_id"
                            label="Concepto"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona un concepto',
                                },
                            ]}
                        >
                            {/* <Conceptos ref={conceptoRef} placeholder="Por favor selecciona un concepto" form={form}/> */}
                            <Select placeholder="Por favor selecciona un concepto" onChange={onChangeConcepto}>
                                {
                                    conceptos.map((item) => <Option value={item.id}>{item.displayTitle}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="clase"
                            label="Clase"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona una clase',
                                },
                            ]}
                        >
                            <Select placeholder="Por favor selecciona una clase">
                                {
                                    clases.map((item) => <Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="monto"
                            label="Monto"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega un monto',
                                },
                            ]}>
                            <InputNumber placeholder="Por favor agrega un monto" style={{ width: '80%', }} />
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="exento"
                            label="Exento"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega un monto',
                                },
                            ]}>
                            <InputNumber placeholder="Por favor agrega un monto" style={{ width: '80%', }} />
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="dias"
                            label="Días"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega los dias',
                                },
                            ]}>
                            <InputNumber placeholder="Por favor agrega los dias" style={{ width: '80%', }} />
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="horas"
                            label="Horas"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega las horas',
                                },
                            ]}>
                            <InputNumber placeholder="Por favor agrega las horas" style={{ width: '80%', }} />
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="analitica_id"
                            label="Analítica"
                        >
                            <Select
                                placeholder="Por favor selecciona una analítica"
                                onChange={changeAnalitica}
                                style={{ width: '80%', }}

                            >
                                {
                                    analiticas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="referencia"
                            label="Referencia"
                        >
                            <Input placeholder="Por favor agrega una referencia" />
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="referencia_tipo_saldo"
                            label="Referencia Tipo Saldo"
                        >
                            <Select placeholder="Por favor selecciona una referencia">
                                {
                                    tiposSaldo.map((item) => <Option value={item.value}>{item.displayTitle}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Space>
                        {
                            ID &&
                            <Button type="default" onClick={onCancelBtn}>
                                Cancelar
                            </Button>
                        }

                        <Button type="primary" htmlType="submit" disabled={!periodObject || (periodObject.status === status_period.cerrado || periodObject.status === status_period.timbrado_parcial)}>
                            Guardar
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Limpiar
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
});

export default App;
